import { Component, computed, WritableSignal } from '@angular/core';
import { LocalizeLanguage } from '../localize-language';
import { FormLocalizationService } from '../form-localization.service';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { InfoButtonComponent } from '../../components/info-button/info-button/info-button.component';

@Component({
    selector: 'localized-form-dropdown',
    templateUrl: './localized-form-dropdown.component.html',
    styleUrl: './localized-form-dropdown.component.scss',
    imports: [SelectModule, FormsModule, InfoButtonComponent]
})
export class LocalizedFormDropdownComponent {

    languages = computed(() => this.formLocalizationService.languages());
    localizeLanguage: WritableSignal<LocalizeLanguage>;

    constructor(private formLocalizationService: FormLocalizationService) {
        this.localizeLanguage = this.formLocalizationService.localizationLanguage;
    }
}
